import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'

function formatTime(dateStr) {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  return d.toLocaleTimeString(undefined, { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' })
}

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null
  return (
    <div className="bg-surface2 border border-border-bright rounded px-3 py-2 text-xs font-mono shadow-xl">
      <p className="text-text-faint mb-1">{label}</p>
      <p className="text-accent font-semibold">
        {(payload[0]?.value ?? 0).toLocaleString()} tokens
      </p>
    </div>
  )
}

export default function TelemetryChart({ events }) {
  // Build chart data from CHECKPOINT and TOOL_CALL events that have token counts
  const chartData = events
    .filter((e) => e.payload?.tokenUsage != null || e.payload?.tokens != null)
    .map((e) => ({
      time: formatTime(e.recordedAt),
      tokens: e.payload?.tokenUsage ?? e.payload?.tokens ?? 0,
    }))
    .slice(-60) // last 60 data points

  return (
    <div className="border border-border rounded-lg bg-surface overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-border bg-surface2">
        <span className="text-2xs font-mono text-text-faint tracking-widest uppercase">
          Token usage over time
        </span>
        <span className="text-2xs font-mono text-text-faint">
          {chartData.length} samples
        </span>
      </div>

      <div className="p-4">
        {chartData.length < 2 ? (
          <div className="flex items-center justify-center h-32">
            <p className="text-xs font-mono text-text-faint">
              {chartData.length === 0
                ? 'No token data in this stream'
                : 'Collecting data…'}
            </p>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={160}>
            <LineChart data={chartData} margin={{ top: 4, right: 4, left: -16, bottom: 0 }}>
              <CartesianGrid
                strokeDasharray="1 4"
                stroke="#22223a"
                vertical={false}
              />
              <XAxis
                dataKey="time"
                tick={{ fill: '#44445a', fontSize: 9, fontFamily: 'JetBrains Mono' }}
                axisLine={{ stroke: '#22223a' }}
                tickLine={false}
                interval="preserveStartEnd"
              />
              <YAxis
                tick={{ fill: '#44445a', fontSize: 9, fontFamily: 'JetBrains Mono' }}
                axisLine={false}
                tickLine={false}
                tickFormatter={(v) => (v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v)}
              />
              <Tooltip content={<CustomTooltip />} />
              <Line
                type="monotone"
                dataKey="tokens"
                stroke="#e8a020"
                strokeWidth={1.5}
                dot={false}
                activeDot={{ r: 3, fill: '#e8a020', stroke: '#0d0d1a', strokeWidth: 2 }}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  )
}
